module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vleg8-c383c79dcf1839c6616d36121362511d.jpg";